import React, { FC, ForwardRefExoticComponent } from 'react';
import { ButtonProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';

import { IconLabelButton } from './index';

const useStyles = makeStyles(theme => ({
  button: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  position: {
    [theme.breakpoints.between('xs', 'md')]: {
      padding: '16px 8px 16px',
    },
  },
}));

interface IProps extends ButtonProps {
  // Short circuit material-ui types
  component?: ForwardRefExoticComponent<any>;
}

const SidebarButton: FC<IProps> = ({ children, component, ...rest }) => {
  const classes = useStyles({});
  const buttonProps = {
    fullWidth: true,
    component,
    ...rest,
  };

  return (
    <div className={classes.position}>
      <IconLabelButton ButtonProps={buttonProps} className={classes.button} icon={AddCircle}>
        {children}
      </IconLabelButton>
    </div>
  );
};

export default SidebarButton;
